import styled, { keyframes, css } from "styled-components";

export const CardsContainer = styled.div`
	display: flex;
	justify-content: space-around;
	width: 100%;
	margin-top: 1rem;
`;

const skeletonAnimation = keyframes`
  100% {
      transform: translateX(100%);
    }
`;

const animationSkeletonCSS = css`
	content: "";
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	transform: translateX(-100%);
	background-image: linear-gradient(
		90deg,
		rgb(255 255 255 / 0%) 0,
		rgba(255, 255, 255, 0.2) 20%,
		rgb(222 222 222 / 50%) 60%,
		rgb(0 0 0 / 0%)
	);
	animation: ${skeletonAnimation} 1s infinite;
`;

export const Cards = styled.div`
	width: 150px;
	height: 200px;
	border-radius: 0.5rem;
	box-shadow: 0px 3px 3px rgb(0 0 0 / 10%);
	position: relative;
	overflow: hidden;
	background-color: var(--white);

	&:after {
		${animationSkeletonCSS}
	}
`;

export const LineSkeleton = styled.td`
	> span {
		background-color: #e6e6e6;
		height: 1rem;
		display: block;
		position: relative;
		overflow: hidden;

		&:after {
			${animationSkeletonCSS}
		}
	}
`;
